import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-config';

export interface UnreadNotificationCountDto {
  count: number;
}

/** docs/design/39 section 11.1: the unread count of one of the person's OTHER Active organizations (the switcher's badge). */
export interface OrganizationUnreadCountDto {
  organizationId: string;
  organizationName: string;
  count: number;
}

/** IsUnread reflects whether this entry was sent after the caller's last mark-all-read, as of the moment
 * this list was fetched - so the dropdown can still show which entries were new even though opening it
 * also clears the badge (docs/design/08... no, this one predates that pattern; see NotificationLogQueryService.GetRecentForUserAsync). */
export interface NotificationInboxItemDto {
  id: string;
  templateKey: string;
  channel: string;
  sentAt: string;
  status: string;
  isUnread: boolean;
  relatedEntityType: string | null;
  relatedEntityId: string | null;
  /** The related record's serial code (WO-202609-0001), resolved by the API; null when there is none or the record is gone. */
  reference?: string | null;
}

/** Backs the header's notification-bell badge and dropdown (docs/design/03_api_contracts.md §5, added 2026-08-04). */
@Injectable({ providedIn: 'root' })
export class NotificationInboxService {
  constructor(private http: HttpClient) {}

  getUnreadCount(): Observable<UnreadNotificationCountDto> {
    return this.http.get<UnreadNotificationCountDto>(`${API_BASE_URL}/users/me/notifications/unread-count`);
  }

  getUnreadCounts(): Observable<OrganizationUnreadCountDto[]> {
    return this.http.get<OrganizationUnreadCountDto[]>(`${API_BASE_URL}/users/me/notifications/unread-counts`);
  }

  getRecent(limit = 10): Observable<NotificationInboxItemDto[]> {
    return this.http.get<NotificationInboxItemDto[]>(`${API_BASE_URL}/users/me/notifications/recent`, { params: { limit } });
  }

  markAllRead(): Observable<void> {
    return this.http.post<void>(`${API_BASE_URL}/users/me/notifications/mark-all-read`, null);
  }
}
